import { Component } from '@angular/core';

@Component({
  selector: 'stat-summary',
  template: `
    <div
      class="flex flex-wrap justify-between border border-t-2 border-solid border-default border-t-brand bg-surface-page"
    >
      <ng-content />
    </div>
    <ng-content select="stat-summary-footer" />
  `,
  host: {
    class: 'block',
  },
})
export class StatSummaryComponent {}
